import Plausible from "plausible-tracker";

// Initialize Plausible
const plausible = Plausible({
  domain: import.meta.env.VITE_PUBLIC_DOMAIN || "localhost",
  trackLocalhost: import.meta.env.MODE === "development",
  apiHost: "https://plausible.io" // Default Plausible host
});

/**
 * Track key conversion goals for business metrics
 */
export const trackPlausibleGoal = (goalName: string): void => {
  plausible.trackEvent(goalName);
};

// Predefined goals for easy tracking
export const PlausibleGoals = {
  USER_SIGNUP: "User Signup",
  USER_LOGIN: "User Login",
  REGISTRATION_CREATED: "Registration Created",
  CSV_EXPORT: "CSV Export",
  SUBSCRIPTION_UPGRADE: "Subscription Upgrade",
  FORM_COMPLETED: "Form Completed"
} as const;
